import {createStyles, WithStyles} from '@material-ui/core';
import {Theme} from 'feedback-system/with-root/typedef';

export const styles = (theme: Theme) => createStyles({
    defaultCard: {
        borderLeft: '3px solid transparent'
    },
    notFount: {
        paddingRight: 100
    },
    reset: {
        paddingRight: '25%',
        verticalAlign: 'bottom',
        paddingBottom: 10,
        fontSize: 16
    },
    defaultColumnWidth: {
        width: '18%'
    }
});

export type Classes = WithStyles<typeof styles>
